import type { GetterTree } from 'vuex'
import type { RootState } from 'store'
import type { ClientState } from './types'

export const getters: GetterTree<ClientState, RootState> = {
  clients: (state: ClientState) => state.clients,
  client: (state: ClientState) => state.client,
  total: (state: ClientState) => state.clients && state.clients.length,
}
